import React from 'react';

const WhiteOnePersonIcon = ({ width = 7, height = 20, fill = '#FFFFFF', ...props }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 7 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.5 0C4.03043 0 4.53914 0.210714 4.91421 0.585786C5.28929 0.960859 5.5 1.46957 5.5 2C5.5 2.53043 5.28929 3.03914 4.91421 3.41421C4.53914 3.78929 4.03043 4 3.5 4C2.96957 4 2.46086 3.78929 2.08579 3.41421C1.71071 3.03914 1.5 2.53043 1.5 2C1.5 1.46957 1.71071 0.960859 2.08579 0.585786C2.46086 0.210714 2.96957 0 3.5 0ZM2 5H5C5.53043 5 6.03914 5.21071 6.41421 5.58579C6.78929 5.96086 7 6.46957 7 7V12.5H5.5V20H1.5V12.5H0V7C0 6.46957 0.210714 5.96086 0.585787 5.58579C0.96086 5.21071 1.46957 5 2 5Z"
        fill={fill}
      />
    </svg>
  );
};

export default WhiteOnePersonIcon;
